// Display text is Norwegian-only as required by Norwegian receipt regulations
const receiptTypeDisplayMap: Record<string, string> = {
  "elektronisk salgskvittering": "Elektronisk salgskvittering",
  "elektronisk returkvittering": "Elektronisk returkvittering",
  "elektronisk proforma-kvittering":
    "Foreløpig kvittering – IKKE KVITTERING FOR KJØP",
  "elektronisk treningskvittering":
    "Treningskvittering – IKKE KVITTERING FOR KJØP",
  "elektronisk utleveringsseddel":
    "Utleveringskvittering – IKKE KVITTERING FOR KJØP",
};

export function getReceiptTypeDisplayText(
  receiptType?: string
): string | null {
  if (!receiptType) return null;
  return receiptTypeDisplayMap[receiptType.toLowerCase()] ?? null;
}
